/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash'
import { useTranslator } from '@jutro/locale';
import { useLocation, withRouter, useHistory } from 'react-router-dom';
import { useModal, Loader } from '@jutro/components';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { GatewayRenewalService as LoadSaveService} from 'twia-capability-gateway-policyrenewal';
import { wizardMessages } from 'twia-portals-wizard-components-ui';
import wizardConfig from './config/twia-commercial-wizard-config.json5';
import TWIAWizardHelper from 'producer-engage/src/overrides/modules-react/twia-portals-wizard-components-ui/Wizard/components/util/TWIAWizardHelper';


const TWIACommercialRenewalWizard = (props) => {
    const [initialSubmission, setInitialSubmission] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const translator = useTranslator();
    const location = useLocation();
    const history = useHistory();
    const { steps, title } = wizardConfig;
    const { viewModelService } = props;
    const { showConfirm } = useModal();
    const { jobNumber } = location?.state;

    const retrieveSubmission = useCallback(() => {
        if (authHeader) {

            LoadSaveService.loadRenewal(jobNumber, authHeader).then((response)=>{
                const responseSubmission = viewModelService.create(
                    response, 
                    'pc', 
                    'edge.capabilities.renewal.dto.RenewalDataDTO');
                
                setInitialSubmission(responseSubmission);
                setIsLoading(false);
            })
        }
    }, [authHeader, jobNumber, viewModelService]);

    useEffect(()=>{
        retrieveSubmission()
    },[retrieveSubmission, authHeader])

    if (isLoading) {
        return <Loader loaded={!isLoading} />
    }

    const getSteps = () => {
        const shouldHideStep = initialSubmission?.value?.baseData?.periodStatus === 'Submitted_Ext';

        return shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps
    }

    const onCancelWithProps = wizardObj => {
        const redirectPath = _.get(wizardObj, 'param', `/renewal/${jobNumber}/summary`);
        const wizardSnapshot = wizardObj.wizardSnapshot;
        const wizardData = wizardObj.wizardData;
        const isSaveAction = document.activeElement?.id === 'gw-wizard-save';
        const cancelProps = { wizardSnapshot, wizardData, showConfirm, translator, wizardMessages, setIsLoading, history, redirectPath, authHeader, isSaveAction };

        return TWIAWizardHelper.handleCancel(cancelProps);
    }

    return (
        <Wizard
            initialSteps={getSteps()}
            wizardTitle={title}
            initialData={initialSubmission}
            location={location}
            skipCompletedSteps
            onCancel={onCancelWithProps}
            onPreviousModalProps={{ title: wizardMessages.TWIAWizardModalTitle,
                message: wizardMessages.TWIAWizardModalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
                cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            }}
        />

    )
}

export default withRouter(withViewModelService(TWIACommercialRenewalWizard));